module.exports = __webpack_public_path__ + "img/jersey.3d7da1a7.png";